var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{attrs:{"custom-class":"nav-tooltip","target":_vm.target,"triggers":_vm.triggers,"placement":_vm.placement,"noninteractive":""}},[_vm._v(" "+_vm._s(_vm.text)+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }